<template>
    <div class="gz-main-container">
        <GZ-Header/>
        <GZ-Content>
            <gz-side-menu slot="menu" v-if="authRole.indexOf('ADMIN') > -1">
                <GZ-SideMenuItem to="/admin/home" icon="icon-dashboard" title="Дашбоард"/>
                <GZ-SideMenuItem to="/admin/addresses" icon="icon-home-run" title="Адреса"/>
                <GZ-SideMenuItem to="/admin/service-entity/list" icon="icon-flag" title="Юридические лица"/>
                <!-- <GZ-SideMenuItem to="/admin/shelters" icon="icon-d" title="Помещения"/> -->
                <GZ-SideMenuItem to="/admin/users/users-list" icon="icon-users" title="Собственники"/>
                <!-- <GZ-SideMenuItem to="/admin/schedule" icon="icon-calendar-classic" title="График проверок"/> -->
                <GZ-SideMenuItem to="/admin/checkups/schedule" icon="icon-clipboard" title="Проверки"/>
                <GZ-SideMenuItem to="/admin/staff/staff-list" icon="icon-hipster" title="Сотрудники"/>
                <GZ-SideMenuItem to="/admin/logout" icon="icon-logout-1" title="Выход" @click.native="logout"/>
            </gz-side-menu>
            <gz-side-menu slot="menu" v-if="authRole.indexOf('PECHNIK') > -1">
                <GZ-SideMenuItem to="/admin/home" icon="icon-dashboard" title="Дашбоард"/>
                <GZ-SideMenuItem to="/admin/addresses" icon="icon-home-run" title="Адреса"/>
                <GZ-SideMenuItem to="/admin/service-entity/list" icon="icon-flag" title="Юридические лица"/>
                <!-- <GZ-SideMenuItem to="/admin/shelters" icon="icon-d" title="Помещения"/> -->
                <GZ-SideMenuItem to="/admin/users/users-list" icon="icon-users" title="Собственники"/>
                <!-- <GZ-SideMenuItem to="/admin/schedule" icon="icon-calendar-classic" title="График проверок"/> -->
                <GZ-SideMenuItem to="/admin/checkups/schedule" icon="icon-clipboard" title="Проверки"/>
                <GZ-SideMenuItem to="/admin/staff/staff-list" icon="icon-hipster" title="Сотрудники"/>
                <GZ-SideMenuItem to="/admin/logout" icon="icon-logout-1" title="Выход" @click.native="logout"/>
            </gz-side-menu>
            <router-view slot="body"/>
        </GZ-Content>
        <GZ-Footer/>
        <GZ-Modal />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AdminLayout',

    computed: {
        ...mapGetters([
            'authRole',
        ])
    },   
    mounted() {
        console.log(this.authRole)
    },
    methods: {
        logout() {
            console.log('test')
            localStorage.removeItem('token')
            this.$router.push('/')
        }
    }
}
</script>